(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ay-us-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ay-hero-motion')) {
  customElements.define('ay-hero-motion', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true;
      const poster = this.closest('.ay-mod-hero__media').querySelector('img');
      this.posterReady = !poster || poster.complete;
      this.sync = () => {
        const src = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        const blocked = this.reduced.matches || (navigator.connection && navigator.connection.saveData);
        if (!src || blocked) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.classList.remove('is-playing');
          return;
        }
        if (!this.posterReady) return;
        if (this.video.getAttribute('src') !== src) {
          this.classList.remove('is-playing');
          this.video.src = src;
          this.video.muted = true;
        }
        if (this.visible && !document.hidden) {
          this.video.play().catch(() => {
            if (this.visible && !document.hidden && !this.video.error) {
              this.classList.remove('is-playing');
            }
          });
        } else {
          this.video.pause();
        }
      };
      this.video.addEventListener('playing', () => {
        this.classList.add('is-playing');
      }, options);
      this.video.addEventListener('error', () => {
        this.classList.remove('is-playing');
      }, options);
      if (poster && !this.posterReady) {
        const posterReady = () => { this.posterReady = true; this.sync(); };
        poster.addEventListener('load', posterReady, options);
        poster.addEventListener('error', posterReady, options);
      }
      this.mobile.addEventListener('change', this.sync, options);
      this.reduced.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      if (navigator.connection) navigator.connection.addEventListener('change', this.sync, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!customElements.get('ay-cart-count')) {
  customElements.define('ay-cart-count', class extends HTMLElement {
    connectedCallback() {
      this.updateCount = event => { this.textContent = event.detail.item_count; };
      document.addEventListener('cart:count:update', this.updateCount);
    }
    disconnectedCallback() { document.removeEventListener('cart:count:update', this.updateCount); }
  });
}
(() => {
  let pending;
  let clearPending;
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('#CartDrawer .ay-cart-rec-form') || !form.checkValidity()) return;
    const card = form.closest('.ay-cart-rec');
    const scroller = card.closest('[data-hdt-scroll-me]');
    const anchor = card.nextElementSibling || card.previousElementSibling;
    pending = {
      scroll: scroller.scrollTop,
      anchor: anchor?.dataset.productId,
      offset: anchor ? anchor.getBoundingClientRect().top - scroller.getBoundingClientRect().top : 0
    };
    clearTimeout(clearPending);
    clearPending = setTimeout(() => { pending = null; }, 15000);
  }, true);
  document.addEventListener('cart:drawer:render', () => {
    if (!pending) return;
    const drawer = document.querySelector('#CartDrawer');
    const scroller = drawer?.querySelector('[data-hdt-scroll-me]');
    if (drawer?.open && scroller) {
      const anchor = pending.anchor && scroller.querySelector(`[data-product-id="${pending.anchor}"]`);
      scroller.scrollTop = pending.scroll;
      if (anchor) scroller.scrollTop += anchor.getBoundingClientRect().top - scroller.getBoundingClientRect().top - pending.offset;
    }
    pending = null;
    clearTimeout(clearPending);
  });
  document.addEventListener('cart:error', () => { pending = null; clearTimeout(clearPending); });
  document.addEventListener('change', event => {
    const select = event.target;
    if (!select.matches('#CartDrawer .ay-cart-rec-form select[name="id"]')) return;
    const option = select.selectedOptions[0];
    const card = select.closest('.ay-cart-rec');
    const img = card.querySelector('.ay-cart-rec-image img');
    if (img && option.dataset.image) {
      img.removeAttribute('srcset');
      img.src = option.dataset.image;
      img.alt = option.dataset.imageAlt;
    }
    card.querySelectorAll('.ay-cart-rec-image, .ay-cart-rec-title').forEach(link => { link.href = option.dataset.url; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
